<template>
  <div>
    <div @click="showAddGroupModal()">
      <slot></slot>
    </div>
    <b-modal :active.sync="isModalShown" scroll="keep" :has-modal-card="true">
      <div class="modal-card" style="width: 500px;">
        <section class="modal-card-body p-lg">
          <form @submit.prevent="onSubmit">
            <div class="title is-5">Создать группу</div>
            <b-field grouped>
              <b-input
                type="text"
                v-model="groupName"
                icon="folder-plus"
                placeholder="Укажите название"
                expanded
              ></b-input>
              <span class="control">
                <b-button type="is-primary" native-type="submit" :loading="loading" :disabled="loading"
                  >Создать</b-button
                >
              </span>
            </b-field>
            <div v-if="error" class="warning has-text-danger">{{ errorMsg }}</div>
          </form>
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'FavouriteAddGroup',

  data() {
    return {
      isModalShown: false,
      error: false,
      errorMsg: '',
      loading: false,
      groupName: ''
    };
  },

  methods: {
    toast(toast) {
      this.$buefy.toast.open({
        message: toast.message,
        type: toast.type,
        position: 'is-bottom'
      });
    },

    showAddGroupModal() {
      this.isModalShown = true;
      this.error = false;
      let now = new Date().toLocaleString('ru-RU');
      this.groupName = `Новая группа ${now}`;
    },

    onSubmit() {
      this.loading = true;
      this.error = false;

      if (this.groupName === '') {
        this.loading = false;
        this.error = true;
        this.errorMsg = 'Укажите название';
        return;
      } else if (this.groupNameAlreadyExist) {
        this.loading = false;
        this.error = true;
        this.errorMsg = 'Название уже используется';
        return;
      }

      this.addFavouriteGroup(this.groupName)
        .then(() => {
          this.loading = false;
          this.groupName = '';
          this.isModalShown = false;
          this.toast({
            message: 'Группа создана',
            type: 'is-warning'
          });
        })
        .catch(error => {
          this.loading = false;
          this.error = true;
          this.errorMsg = `Ошибка. ${error}`;
        });
    },

    ...mapActions('favourites', { addFavouriteGroup: 'addFavouriteGroup' })
  },

  computed: {
    ...mapState({
      favouriteGroups: state => state.favourites.favouriteGroups
    }),

    groupNameAlreadyExist() {
      return this.favouriteGroups.some(el => el.name === this.groupName);
    }
  }
};
</script>

<style scoped></style>
